import { render, staticRenderFns } from "./Installatori.vue?vue&type=template&id=0cca140c&scoped=true&"
import script from "./Installatori.vue?vue&type=script&lang=js&"
export * from "./Installatori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca140c",
  null
  
)

export default component.exports